import Vue from "vue/dist/vue.esm"
import template from "./staff_members_template.slim"
import { VueGoodTable } from "vue-good-table"

Vue.component("staff-list", {
  mixins: [template],
  components: {
    VueGoodTable,
  },
  props: ["staff_member_rows", "teacher_learning", "classrooms_label", "show_action_column"],
  mounted() {
    $(document).on("click", ".resend-button", function(e) {
      e.preventDefault()
      e.stopPropagation()
      const button = $(this)
      $.ajax({
        url: button.attr("href"),
        type: "post",
        contentType: "application/json",
        dataType: "json",
      })
        .done(function(response) {
          let message;
          if (response.code === 200) {
            message = "Invitation sent"
          } else {
            message = "Invitation wasn't sent"
          }
          button.after(`<span class="block">${message}</span>`);
          button.remove();
        })
        .fail(function() {
          button.after("<span class='block'>Unable to resend invitation</span>");
        })
    })
  },
  data() {
    return {
      columnsForStaffMembers: [
        {
          label: "Name",
          field: "name",
          sortable: true,
          sortFn: this.sortFn,
          html: true,
          tdClass: "staff-name",
          tdClass: "bold-link",
        },
        {
          label: "Roster ID",
          field: "rosterId",
        },
        {
          label: "Role",
          field: "role",
        },
        {
          label: `${this.classrooms_label} As Observer`,
          field: "classroomAsObserver",
        },
        {
          label: `${this.classrooms_label} As Learner`,
          field: "classroomsAsLearner",
          hidden: !this.teacher_learning,
        },
        {
          label: "Tags",
          field: "tags",
        },
        {
          label: "Last Activity",
          field: "lastActivity",
        },
        {
          label: "",
          field: "actions",
          sortable: true,
          sortFn: this.sortFn,
          html: true,
          tdClass: "resend-invite-button",
          tdClass: "action-button",
          hidden: !this.show_action_column
        },
      ],
    }
  },
  methods: {
    sortFn(x, y) {
      x = x.replace(/<\/?a[^>]*>/g, "")
      y = y.replace(/<\/?a[^>]*>/g, "")
      return x < y ? -1 : x > y ? 1 : 0
    },
    deactivateSelectedStaffMembers() {
      const selectedRows = this.$refs["staff-table"].selectedRows;
      const schoolSlug = this.$schoolSlug;
      const $modal = $(".modal.staff-deactivation-confirmation-modal");
      $modal.find("#submit-button").off("click").on("click", function () {
        const staffIds = selectedRows.map(row => row.id);
        const suppressData = $modal.find("input[name='suppress_data_option']:checked").val();

        $.ajax({
          url: `/go/${schoolSlug}/staff/batch_deactivate`,
          method: "POST",
          data: { staff_ids: staffIds, suppress_data: suppressData },
        })
      });
      $modal.addClass("modal-open");
    }
  }
})
